/**
 * useComplete hook.
 */
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useState } from 'react';

export default function useComplete() {
  const currentParams = useAppSelector(selectCurrentParams);
  return useState<boolean>(
    (currentParams as { complete: boolean })?.complete || false
  );
}
